import React from 'react'
import { useTranslation } from 'react-i18next'

import { RadioTabItem, RadioTabs } from 'aem-libs-react-ts/src/components/Inputs/RadioTabs'
import { InvestorType, InvestorTypeValue } from 'aem-libs-regular-investment/src/services/types'

import { RF_INVESTOR_TYPE_INPUT } from '../constants'

interface IProps {
  selectedType: InvestorTypeValue
  label: string
  onSelect: (type: InvestorTypeValue) => void
}

const InvestorSelect = ({ selectedType, onSelect, label }: IProps) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='csas-calc-controls-label csas-calc-controls-label-fixed-medium'>{label}</div>
      <div className='csas-calc-controls-group' data-rf={RF_INVESTOR_TYPE_INPUT.LIST}>
        <RadioTabs onChange={onSelect}>
          <RadioTabItem
            id='1'
            name='investorType'
            label={t('INVESTMENT_TYPE.CONSERVATIVE')}
            value={InvestorType.conservative}
            checked={selectedType === InvestorType.conservative}
            showTip={true}
            tipOptions={{
              tip: t('INVESTMENT_TYPE.CONSERVATIVE_TIP'),
              position: 'left'
            }}
            rf={RF_INVESTOR_TYPE_INPUT.CONSERVATIVE}
          />
          <RadioTabItem
            id='2'
            name='investorType'
            label={t('INVESTMENT_TYPE.BALANCED')}
            value={InvestorType.balanced}
            checked={selectedType === InvestorType.balanced}
            showTip={true}
            tipOptions={{
              tip: t('INVESTMENT_TYPE.BALANCED_TIP'),
              position: 'left'
            }}
            rf={RF_INVESTOR_TYPE_INPUT.BALANCED}
          />
          <RadioTabItem
            id='3'
            name='investorType'
            label={t('INVESTMENT_TYPE.DYNAMIC')}
            value={InvestorType.dynamic}
            checked={selectedType === InvestorType.dynamic}
            showTip={true}
            tipOptions={{
              tip: t('INVESTMENT_TYPE.DYNAMIC_TIP'),
              position: 'left'
            }}
            rf={RF_INVESTOR_TYPE_INPUT.DYNAMIC}
          />
          <RadioTabItem
            id='4'
            name='investorType'
            label={t('INVESTMENT_TYPE.AGGRESSIVE')}
            value={InvestorType.aggressive}
            checked={selectedType === InvestorType.aggressive}
            showTip={true}
            tipOptions={{
              tip: t('INVESTMENT_TYPE.AGGRESSIVE_TIP'),
              position: 'left'
            }}
            rf={RF_INVESTOR_TYPE_INPUT.AGGRESSIVE}
          />
        </RadioTabs>
      </div>
    </>
  )
}

export default InvestorSelect
